import { Swiper } from 'swiper';
import { A11y, Navigation, Pagination } from 'swiper/modules';

const blocks = document.querySelectorAll('.block-related-resources-slider');

if (blocks.length > 0) {
	blocks.forEach((block) => {
		const slider = block.querySelector(
			'.block-related-resources-slider .swiper'
		);

		if (!slider) {
			return;
		}

		let cardsPerRow = 3;

		if (block.hasAttribute('data-cards-per-row')) {
			cardsPerRow = parseInt(block.getAttribute('data-cards-per-row'));
		}

		const slides = slider.querySelectorAll('.swiper-slide');

		const settings = {
			loop: false,
			grabCursor: true,
			spaceBetween: 10,
			slidesPerView: 1,
			modules: [A11y, Navigation, Pagination],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			navigation: {
				prevEl: slider.parentElement.querySelector(
					'.swiper-button-prev'
				),
				nextEl: slider.parentElement.querySelector(
					'.swiper-button-next'
				),
			},
			pagination: {
				el: slider.parentElement.querySelector('.swiper-pagination'),
				type: 'progressbar',
				clickable: true,
			},
			breakpoints: {
				576: {
					slidesPerView: 2,
					loop: slides.length > 2 ? true : false,
				},
				992: {
					spaceBetween: 32,
					slidesPerView: 3,
					loop: false,
				},
				1200: {
					spaceBetween: 32,
					slidesPerView: cardsPerRow,
					loop: false,
				},
			},
		};

		new Swiper(slider, settings);
	});
}
